import dayjs from "dayjs";
import * as yup from "yup";
import { FISCAL_CODE_REG_EXP, ITALY_CODE } from "../../config";
import {ICustomerData, ICustomerDataForm, IGenericOption, IRecoveryRaReasonForm} from "../../models/models";
import {MAX_CHAR_TEXTAREA} from "../config";

export const ADDITIONAL_DRIVER_INIT_VALUE: ICustomerData = {
    name: '',
    surname: '',
    gender: null,
    fiscalCode: '',
    customerID: '',
    certifiedEmail: '',
    cbId: '',
    customerType: '',
    birthDate: null,
    birthPlace: '',
    birthNation: null,
    residenceCity: '',
    residenceProvince: null,
    residenceCountry: null,
    addressGoogleSearch: '',
    cfValidated: null,
    address: '',
    streetNumber: '',
    postcode: '',
    prefix: null,
    mobile: '',
    email: '',
    drivingLicenseNumber: '',
    drivingLicenseCategory: null,
    issuingAuthority: '',
    issuingDate: null,
    drivingLicenseIssuingCountry: null,
    drivingLicenseIssuingProvince: null,
    drivingLicenseFirstReleaseDate: null,
    expireDate: null,
    /* drivingLicenseDoc: null, */
    issuingPlace: null,
    /*  idDoc: null, */
    idNumber: '',
    idType: '',
    idIssueDate: null,
    idExpiryDate: null,
    idIssuingAuthority: '',
    idIssuingCountry: null,
    idIssuingProvince: null,
    idIssuingPlace: null,
    citizenship: null,
    uuid: '',
    idDocCode: null,
    idDocFront: null,
    idDocBack: null,
    dossierIdentifier: '',
    drivingLicenseDocCode: null,
    drivingLicenseDocFront: null,
    drivingLicenseDocBack: null,
    drivingLicenseDocTitleFront: '',
    drivingLicenseDocPathFront: '',
    drivingLicenseDocTitleBack: '',
    drivingLicenseDocPathBack: '',
    idDocTitleFront: '',
    idDocPathFront: '',
    idDocTitleBack: '',
    idDocPathBack: ''
}

// Form's initial values
export const CUSTOMER_DATA_FORM_INITIAL_VALUES: ICustomerDataForm = {
    mainDriver: {
        name: '',
        surname: '',
        gender: null,
        fiscalCode: '',
        customerID: '',
        certifiedEmail: '',
        cbId: '',
        customerType: '',
        birthDate: null,
        birthPlace: '',
        birthNation: null,
        residenceCity: '',
        residenceProvince: null,
        residenceCountry: null,
        addressGoogleSearch: '',
        address: '',
        streetNumber: '',
        postcode: '',
        prefix: null,
        mobile: '',
        email: '',
        drivingLicenseNumber: '',
        drivingLicenseCategory: null,
        issuingAuthority: '',
        issuingDate: null,
        drivingLicenseIssuingCountry: null,
        drivingLicenseIssuingProvince: null,
        drivingLicenseFirstReleaseDate: null,
        expireDate: null,
        /* drivingLicenseDoc: null, */
        issuingPlace: null,
        /*  idDoc: null, */
        idNumber: '',
        idType: '',
        idIssueDate: null,
        idExpiryDate: null,
        idIssuingAuthority: '',
        idIssuingCountry: null,
        idIssuingProvince: null,
        idIssuingPlace: null,
        citizenship: null,
        uuid: '',
        idDocCode: null,
        idDocFront: null,
        idDocBack: null,
        dossierIdentifier: '',
        drivingLicenseDocCode: null,
        drivingLicenseDocFront: null,
        drivingLicenseDocBack: null,
        verifiedDocuments: null,
        drivingLicenseDocTitleFront: '',
        drivingLicenseDocPathFront: '',
        drivingLicenseDocTitleBack: '',
        drivingLicenseDocPathBack: '',
        idDocTitleFront: '',
        idDocPathFront: '',
        idDocTitleBack: '',
        idDocPathBack: ''
    },
    additionalDrivers: []
}

export const REASON_RECOVERY_RA_FORM_INITIAL_VALUES : IRecoveryRaReasonForm = {
    reason: '',
    effectivePickupDate: null
}

export const REASON_RECOVERY_RA_VALIDATION_SCHEMA = yup.object()
    .shape({
        reason: yup.string()
            .required('common.error.required')
            .test({
                name: 'maxCharatsNum',
                message: "common.error.maxCharatsNum",
                test(value, context) {
                    return !!value && value.length <= MAX_CHAR_TEXTAREA;
                }
            }),
        effectivePickupDate: yup
            .date()
            .nullable()
            .typeError('common.error.invalidDate')
            .required('common.error.required')
            .test({
                name: 'effectivePickupDateValidation',
                message: 'common.error.invalidDate',
                test(value, context) {
                    console.log(context.options?.context);
                    return !!value && !!context.options?.context?.minDate && !!context.options?.context?.maxDate ?
                        (dayjs(value).isSame(context.options.context.minDate) || dayjs(value).isAfter(context.options.context.minDate))
                        && (dayjs(value).isSame(context.options.context.maxDate) || dayjs(value).isBefore(context.options.context.maxDate))
                            : true;
                }
            })
    })

export const DRIVER_VALIDATION_SCHEMA = yup
    .object()
    .shape({
        name: yup
            .string()
            .required("common.error.required"),
        surname: yup
            .string()
            .required("common.error.required"),
        gender: yup
            .object({
                code: yup.string().required()
            })
            .nullable()
            .required('common.error.required'),
        fiscalCode: yup
            .string()
            .test({
                name: 'cfNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return context.parent.residenceCountry?.code !== ITALY_CODE || !!value;
                }
            })
            .matches(FISCAL_CODE_REG_EXP, {
                message: 'common.error.invalidFS',
                excludeEmptyString: true
            }),
        customerID: yup.string(),
        customerType: yup.string().nullable(),
        birthDate: yup
            .date()
            .nullable()
            .typeError('common.error.invalidDate')
            .max(dayjs(dayjs().year(dayjs().year() - 21)), 'common.error.21yearsOld')
            .required('common.error.required'),
        birthPlace: yup
            .string()
            .required('common.error.required'),
        birthNation: yup.object()
            .nullable()
            .required('common.error.required'),
        residenceCity: yup
            .string()
            .required('common.error.required'),
        residenceProvince: yup
            .object()
            .nullable()
            // .required("common.error.required")
            .when('residenceCountry', {
                is: (residenceCountry: any) => residenceCountry?.code === ITALY_CODE,
                then: (schema) => schema.required("common.error.required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        residenceCountry: yup
            .object()
            .nullable()
            .required("common.error.required"),
        address: yup
            .string()
            .required("common.error.required"),
        streetNumber: yup
            .string()
            .nullable()
            .required('common.error.required')
            .max(10, "common.error.maxStreetNumChearLength"),
        postcode: yup
            .string()
            .required("common.error.required"),
        prefix: yup
            .object()
            .nullable()
            .required("common.error.required"),
        mobile: yup
            .string()
            .nullable()
            .required("common.error.required"),
        email: yup
            .string()
            .email('common.error.email.isNotValid')
            .required("common.error.required"),
        drivingLicenseNumber: yup
            .string()
            /* .nullable() */
            .required("common.error.required"),
        drivingLicenseCategory: yup
            .string()
            .nullable()
            .required("common.error.required"),
        issuingAuthority: yup
            .string()
            .required("common.error.required"),
        issuingDate: yup
            .date()
            .nullable()
            .typeError('common.error.invalidDate')
            .max(dayjs(), 'common.error.lessThanCurrentDay')
            .required('common.error.required'),
        expireDate: yup
            .date()
            .nullable()
            .typeError('common.error.invalidDate')
            .required('common.error.required')
            .test({
                name: 'greaterThanIssuingDate',
                message: 'common.error.greaterThanIssuingDate',
                test(value, context) {
                    return !!value && !!context.parent.issuingDate ? dayjs(value).isAfter(context.parent.issuingDate) : true;
                }
            })
            .test({
                name: 'expireDate',
                message: 'common.error.expireDate',
                test(value, context) {
                    const pickUpDate = dayjs(context.options.context?.effectivePickupDate).set("hour", 0).set("minute", 0).set("millisecond", 0);
                    return context.options.context?.recoveryMode && !!context.options.context?.effectivePickupDate && !!value ? 
                            dayjs(value).isAfter(pickUpDate) || dayjs(value).isSame(pickUpDate)
                        : !!value && !context.options.context?.recoveryMode ?
                            dayjs(value).isAfter(dayjs()) || dayjs(value).isSame(dayjs(), 'day') : true;
                }
            }),
        drivingLicenseDocFront: yup
            .mixed()
            .nullable()
            .required('common.error.required'),
        drivingLicenseDocBack: yup
            .mixed()
            .nullable()
            .required('common.error.required'),
        citizenship: yup
            .object()
            .nullable()
            .required("common.error.required"),
        issuingPlace: yup
            .object()
            .nullable()
            .required("common.error.required"),
        drivingLicenseFirstReleaseDate: yup
            .date()
            .typeError('common.error.invalidDate')
            .nullable()
            .required("common.error.required")
            .max(dayjs().subtract(1, 'y'), 'common.error.drivingLicenseFirstReleaseDate')
            .test({
                name: 'lessEqualThanIssuingDate',
                message: 'common.error.lessEqualThanIssuingDate',
                test(value, context) {
                    const valueDate = dayjs(value).startOf('day');
                    const issuingDate = dayjs(context.parent.issuingDate).startOf('day');
                    return !!value && !!context.parent.issuingDate
                            ? valueDate.isBefore(issuingDate) || valueDate.isSame(issuingDate)
                            : true;
                    //return !!value && !!context.parent.issuingDate ? dayjs(value).isBefore(context.parent.issuingDate) || dayjs(value).isSame(context.parent.issuingDate)  : true;
                }
            }),
        drivingLicenseIssuingCountry: yup
            .string()
            .nullable()
            .required("common.error.required"),
        idExpiryDate: yup
            .date()
            .typeError('common.error.invalidDate')
            .nullable()
            .min(dayjs(), "common.error.expireDate")
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idIssuingPlace && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            }),
        idDocFront: yup
            .mixed()
            .nullable()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idIssuingPlace && !context.parent.idExpiryDate && !context.parent.idDocBack) || !!value;
                }
            }),
        idDocBack: yup
            .mixed()
            .nullable()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idIssuingPlace && !context.parent.idExpiryDate && !context.parent.idDocFront) || !!value;
                }
            }),
        idNumber: yup
            .string()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idIssuingPlace && !context.parent.idExpiryDate && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            }),
        /* idType: yup
            .string()
            .when(['idDocFront', 'idDocBack'], {
                is: (idDocFront: File | null, idDocBack: File | null) => idDocFront && idDocBack,
                then: schema => schema.required('common.error.required'),
                otherwise: schema => schema
            }), */
        idIssueDate: yup
            .date()
            .typeError('common.error.invalidDate')
            .nullable()
            .max(dayjs(), 'common.error.lessThanCurrentDay')
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssuingPlace && !context.parent.idExpiryDate && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            })
            .test({
                name: 'lessThanExpiryDate',
                message: 'common.error.lessThanExpiryDate',
                test(value, context) {
                    return !!value && !!context.parent.idExpiryDate ? dayjs(value).isBefore(context.parent.idExpiryDate) : true;
                }
            }),
        idIssuingAuthority: yup
            .string()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssueDate && !context.parent.idIssuingPlace && !context.parent.idExpiryDate && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            }),
        idIssuingPlace: yup
            .object()
            .nullable()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idExpiryDate && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            }),
        idIssuingCountry: yup
            .string()
            .nullable()
            .test({
                name: 'docFrontNotRequired',
                message: "common.error.required",
                test(value, context) {
                    return (context.parent.residenceCountry?.code === ITALY_CODE && !context.parent.idNumber && !context.parent.idIssuingAuthority && !context.parent.idIssueDate && !context.parent.idExpiryDate && !context.parent.idDocFront && !context.parent.idDocBack) || !!value;
                }
            }),
    }, [
        ['idDocFront', 'idNumber'],
        ['idDocFront', 'idIssuingAuthority'],
        ['idDocFront', 'idIssueDate'],
        ['idDocFront', 'idIssuingPlace'],
        ['idDocFront', 'idExpiryDate'],
        ['idDocBack', 'idNumber'],
        ['idDocBack', 'idIssuingAuthority'],
        ['idDocBack', 'idIssueDate'],
        ['idDocBack', 'idIssuingPlace'],
        ['idDocBack', 'idExpiryDate']
    ]);

// Validation Schema
export const CUSTOMER_DATA_FORM_VALIDATION_SCHEMA = yup.object({
    mainDriver: DRIVER_VALIDATION_SCHEMA,
    additionalDrivers: yup
        .array()
        .of(DRIVER_VALIDATION_SCHEMA),
});

export enum PAYMENT_TIMING {
    PREPAID = '1',
    PAY_ON_ARRIVAL = '2',
}

export const INIT_DRIVER_FIELDS_STATE = {
    name: false,
    surname: false,
    gender: false,
    fiscalCode: false,
    birthDate: false,
    birthPlace: false,
    birthNation: false,
    residenceCity: false,
    residenceProvince: false,
    residenceCountry: false,
    addressGoogleSearch: false,
    address: false,
    streetNumber: false,
    postcode: false,
    prefix: false,
    mobile: false,
    email: false,
    drivingLicenseNumber: false,
    drivingLicenseCategory: false,
    issuingAuthority: false,
    issuingDate: false,
    drivingLicenseIssuingCountry: false,
    drivingLicenseIssuingProvince: false,
    drivingLicenseFirstReleaseDate: false,
    expireDate: false,
    issuingPlace: false,
    idNumber: false,
    idIssueDate: false,
    idExpiryDate: false,
    idIssuingAuthority: false,
    idIssuingCountry: false,
    idIssuingProvince: false,
    idIssuingPlace: false,
    citizenship: false,
    idDocFront: false,
    idDocBack: false,
    drivingLicenseDocFront: false,
    drivingLicenseDocBack: false
}

export enum DriverCheckLabel {
    FISCAL_CODE = "taxCode",
    DRIVING_LICENCE = "drvLicenceNumber",
    EMAIL = "email"
}